import { Controller } from "stimulus";

export default class FixedPlayerController extends Controller {
  connect() {
    window.addEventListener("supercast-timeupdate", this.update.bind(this));
    window.addEventListener("supercast-playback-ended", this.loadNextEpisode.bind(this));
    window.addEventListener("supercast-queue-changed", this.refreshUpNextFromQueue.bind(this));
    const currentEpisodeId = null;
  }

  update(event) {
    if (event.detail.mediaType != 'audio') {
      this.hide();
      return;
    }
    this.show();
    if (event.detail.itemId == this.currentEpisodeId) {
      return;
    }
    this.currentEpisodeId = event.detail.itemId;

    if (event.detail.itemType == "Episode") {
      this.fetchMetadataStream(event.detail.itemId)
        .then(() => this.refreshUpNextFromQueue())
        .catch((error) => console.error(error));
      this.setFeedTokenConnected(event.detail.itemId);
    }
  }

  show() {
    this.element.hidden = false;
  }

  hide() {
    this.element.hidden = true;
  }

  fetchMetadataStream(episodeId) {
    return fetch(`/subscriber_v2/episodes/${episodeId}/metadata${window.location.search}`, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
      }
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html));
  }

  setFeedTokenConnected(episodeId) {
    fetch(`/subscriber_v2/feed_items/mark_feed_token_connected?episode_id=${episodeId}`, {
      method: "POST"
    });
  }

  refreshUpNextFromQueue() {
    const requestToken = (this.upNextRequestToken = (this.upNextRequestToken || 0) + 1);
    const episodeId = this.currentEpisodeId;
    const isStale = () => requestToken !== this.upNextRequestToken || episodeId != this.currentEpisodeId;

    return window.queueDb.getQueue().then((queue) => {
      if (isStale()) return;

      const head = queue[0];
      if (!head) {
        this.upNextQueueItemId = null;
        this.upNextQueueEpisodeId = null;
        return this.fetchMetadataStream(episodeId).catch((error) => console.error(error));
      }

      return fetch(`/subscriber_v2/episodes/${head.itemId}/queue_next`, {
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
        }
      })
        .then(response => {
          if (!response.ok) throw new Error(`Failed to fetch queue_next: ${response.status}`);
          return response.text();
        })
        .then(html => {
          if (isStale()) return;
          Turbo.renderStreamMessage(html);
          this.upNextQueueItemId = head.id;
          this.upNextQueueEpisodeId = head.itemId;
        })
        .catch((error) => {
          console.error(error);
          if (isStale()) return;
          this.upNextQueueItemId = null;
          this.upNextQueueEpisodeId = null;
        });
    });
  }

  loadNextEpisode() {
    if (this.hasNextEpisodePlayButtonTarget) {
      const playButtonElement = this.nextEpisodePlayButtonTarget.querySelector("[data-controller='play-button']");
      if (playButtonElement) {
        const playController = this.application.getControllerForElementAndIdentifier(playButtonElement, "play-button");
        if (playController) {
          playController.play();
        }
      }
    }

    if (this.upNextQueueItemId != null) {
      const dequeuedId = this.upNextQueueItemId;
      this.upNextQueueItemId = null;
      this.upNextQueueEpisodeId = null;
      window.queueDb.removeFromQueue(dequeuedId)
        .then(() => {
          window.dispatchEvent(new CustomEvent("supercast-queue-changed"));
        })
        .catch((error) => console.error(error));
    }
  }
}

FixedPlayerController.targets = ['nextEpisodePlayButton'];
